<template>
  <div>
    <template v-if="integrationStatus == 'Disabled'">
      <span class="badge badge-danger"
        >Disabled</span
      >
    </template>
    <template v-else-if="integrationStatus == 'Pending'">
      <span class="badge badge-info"
        >Pending Review</span
      >
    </template>
    <template v-else-if="integrationStatus == 'Paused'">
      <span class="badge badge-dark"
        >Paused</span
      >
    </template>
    <template v-else-if="integrationStatus == 'PendingClientAction'">
      <span class="badge badge-warning"
        >Pending Client Action</span
      >
    </template>
    <template v-else>
      <span class="badge badge-success badge-green"
        >Active</span
      >
    </template>
  </div>
</template>

<script lang="js">
export default {
  props: {
    integrationStatus: {
      required: true
    }
  }
}
</script>

<style>

</style>
